
let instance = null;
class AppConfig {
    constructor(){
        if (!instance) {
            this.init();
            instance = this;
        }
        return instance;
    }

    init() {
        this.debug_mode = false;
        this.api = {
            https: true,
            baseUrl: window.base_url,
            path: "api",
            platform: 'website',
            version: '1.0',
            requests: {
                generalDeclaration: 'generalDeclaration',
                sendBusinessLead: 'sendBusinessLead',
                subscribeToNewsletter: 'subscribeToNewsletter',
                getCarsByQuery: 'getCarsByQuery',
                getManufacturers: 'getManufacturers',
                getCars: 'getCars',
                getCar: 'getCar',
                newLead:'newLead',
                sendOrderSMS:'sendOrderSMS',
                checkOrderSMS:'checkOrderSMS',
                createOrder:'createOrder',
                getContentPage:'getContentPage',
                getAppointments:'getAppointments',
                GetOrderDetail:'GetOrderDetail',
                getMetaTags: 'getMetaTags',
            },
        };
        this.full_path = (this.api.https ? 'https' : 'http') + '://' + this.api.baseUrl;
        this.token = this.getToken();
    }

    /*--------------------------------------------------------------------------------------------------------------------*/
    //caching
    getToken = () => localStorage.getItem('token');

    setToken = (token) => {
        localStorage.setItem('token', token);
    }
};

export default AppConfig;